import { GatsbyImage } from "gatsby-plugin-image";
import React, { memo } from "react";
import { Link } from "../../utils/link";

const Banner = ({
  title,
  description,
  buttonText = "",
  buttonLink = "",
  bgImage,
  paddingBottom,
  objectPosition,
}) => {
  return (
    <div className={`max-w-full w-full px-[10px] ${!paddingBottom && "mb-10"}`}>
      <div className="relative block w-full h-full rounded-[10px] overflow-hidden border-inherit">
        {/* Image Section */}
        <div
          className={`relative w-full h-full border-inherit pb-[120%] sm:pb-[70%] ${
            (paddingBottom ? `md:pb-[${paddingBottom}]` : "md:pb-[40%]",
            paddingBottom ? `lg:pb-[${paddingBottom}]` : "lg:pb-[30%]")
          }`}
        >
          {bgImage?.gatsbyImageData && (
            <div className="absolute top-0 left-0 max-w-full block w-full h-full">
              <GatsbyImage
                image={bgImage.gatsbyImageData}
                alt={bgImage.title || " "}
                className="relative block w-full h-full transition-opacity duration-[400ms]"
                objectFit="cover"
                objectPosition={objectPosition ?? "center"}
                loading="lazy"
              />
            </div>
          )}
        </div>
        <div
          className="absolute top-0 left-0 bottom-0 flex flex-col items-start justify-end bg-black/30 p-5 md:p-10
          w-full text-white border-inherit"
        >
          <h2 className="mb-[10px] text-xl md:text-3xl tracking-[0.4px] leading-[30px] md:leading-[45px] font-bold">
            {title}
          </h2>
          <div className="max-w-[600px] w-full text-left border-inherit">
            <p className="w-full tracking-[0.4px] text-[15px] md:text-base leading-7">
              {description}
            </p>
          </div>
          <Link
            to={buttonLink}
            className="bg-white text-[#1f1f1f] w-fit mt-5 py-4 px-9 rounded-full hover:scale-105 transition-all 
            duration-200 ease-linear font-bold"
          >
            {buttonText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default memo(Banner);
